import fetch from 'isomorphic-fetch'
export const initialState = [];
export const tabinit = 0;
export const CHANGE_TAB = 'CHANGE_TAB'; 
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';
//多國
export const Phrases = require('../data/lang.json')

/*
 * action creators
 *
 *這裡透過這兩個action creators，可以將action types
 *集中在這裡面管理，只要傳入值就可以回傳呼應相對應的reduces的格式
 */
export function fetchValue(jsonData, action_type){
  return {type: action_type, data: jsonData}
}

export function changeTab(int){
  return {type: CHANGE_TAB, data: int}
}

//multi lang
export function switchLanguageEn(){
  localStorage.setItem('defaultLang', 'en');
  return {type: SWITCH_LANGUAGE, language: 'en'}
}

export function switchLanguageTw(){      
  localStorage.setItem('defaultLang', 'tw');
  return {type: SWITCH_LANGUAGE, language: 'tw'}
}

/*
 * Async actions
 * thunk action creators
 */
 function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

function parseJSON(response) {
  return response.json()
}

export function fetchGetData(actionType, dataPath) {
  return (dispatch, getState) => {
   fetch(dataPath)
    .then(checkStatus)
    .then(parseJSON)
    .then(jsonData=>dispatch(fetchValue(jsonData, actionType)))
    .catch(error => alert('An error occured.', error))
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js